import ApiService from './ApiService';

class ShareFreezingService {
  async performFreeze(payload = {}) {
    try {
      const response = await ApiService.call('/secured/perform_freeze', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new ShareFreezingService();